export enum ButtonTypes {
  submit = 'submit',
  reset = 'reset',
  button = 'button',
}
